import type { HTMLAttributes } from 'react';
import { cn } from '../lib/cn';
import './Badge.css';

export type BadgeTone = 'neutral' | 'brand' | 'amber' | 'coral' | 'success' | 'info';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
  /** Formato pílula (totalmente arredondado). Default true. */
  pill?: boolean;
  /** Variante sólida (preenchida) em vez de suave. */
  solid?: boolean;
  /** Usa fonte monoespaçada (protocolos, IDs). */
  mono?: boolean;
}

export function Badge({
  tone = 'neutral',
  pill = true,
  solid = false,
  mono = false,
  className,
  children,
  ...rest
}: BadgeProps): JSX.Element {
  return (
    <span
      className={cn(
        'cf-badge',
        `cf-badge--${tone}`,
        solid ? 'cf-badge--solid' : 'cf-badge--soft',
        pill ? 'cf-badge--pill' : 'cf-badge--rounded',
        mono && 'cf-badge--mono',
        className,
      )}
      {...rest}
    >
      {children}
    </span>
  );
}

/** Alias semântico — Pill é um Badge pílula. */
export function Pill(props: BadgeProps): JSX.Element {
  return <Badge pill {...props} />;
}
